import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 06 2018
 * @author SKu
 */
import { FinalPriceType, Utils, ValidationError, ValidationLevel, ValidationResultWrapper } from '@logio/common-be-fe';
import * as React from 'react';
import FormGroupInline from '../../../../forms/FormGroupInline/FormGroupInline';
import translate from '../../../../i18n/translate';
import { InputValidated } from '../../../../inputs/Input';
import Select from '../../../../inputs/Select';
import CellEditor from './CellEditor';
export var ReleaseItemFinalPriceEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(ReleaseItemFinalPriceEditor, _CellEditor);

  function ReleaseItemFinalPriceEditor(props) {
    var _this;

    _classCallCheck(this, ReleaseItemFinalPriceEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemFinalPriceEditor).call(this, props));
    /** Valid validation result used to omit NOT_VALID state from validationResult object(alerts) */

    _this.validValidationResult = {
      validationResult: new ValidationResultWrapper()
    };
    /**
     * Select options
     * Manual price is changeable, so will be shown without value
     */

    _this.selectOptions = [{
      label: translate("".concat(FinalPriceType.Manual, "-finalPrice")),
      value: FinalPriceType.Manual
    }];
    /**
     * Returns select options depending on priceType
     * @param priceType
     */

    _this.createSelectOption = function (priceType) {
      return {
        label: "".concat(translate("".concat(priceType, "-finalPrice")), " - ").concat(_this[priceType]),
        value: priceType
      };
    };
    /**
     * Update cell value and set selected price to input
     */


    _this.onSelectChange = function (value) {
      var updatedValue = {
        priceType: value,
        value: value === FinalPriceType.Manual ? _this.state.value.value : _this[value],
        validationResult: _this.validValidationResult
      };

      _this.updateValue(Object.assign(Object.assign({}, _this.state.value), updatedValue));
    };
    /**
     * Handles changes of the input element
     */


    _this.onInputChange = function (e) {
      var updatedValue = {
        value: isNaN(e.target.valueAsNumber) ? undefined : e.target.valueAsNumber
      };
      var finalPrice = Object.assign(Object.assign(Object.assign({}, _this.state.value), updatedValue), {
        validationResult: _this.validValidationResult
      }); //LOG_6390

      /**
       * if price already exists, we should set priceType in required order:
       * OP
       * OPW
       * ARP
       * If none of those prices matches, MP should be chosen
       */
      // switch (finalPrice.value) {
      //   case this[FinalPriceType.OptimalWithoutConstraints]:
      //     this.updateValue({...finalPrice, ...{priceType: FinalPriceType.OptimalWithoutConstraints}});
      //     break;
      //   case this[FinalPriceType.OptimalWithConstraints]:
      //     this.updateValue({...finalPrice, ...{priceType: FinalPriceType.OptimalWithConstraints}});
      //     break;
      //   case this[FinalPriceType.Regular]:
      //     this.updateValue({...finalPrice, ...{priceType: FinalPriceType.Regular}});
      //     break;
      //   default:
      //     this.updateValue({...finalPrice, ...{priceType: FinalPriceType.Manual}});
      //     break;
      // }

      _this.updateValue(Object.assign(Object.assign({}, finalPrice), {
        priceType: FinalPriceType.Manual
      }));
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(FormGroupInline, {
        right: false
      }, React.createElement(Select, {
        options: _this.selectOptions,
        value: _this.state.value.priceType,
        className: "ag-cell-editor",
        onChange: _this.onSelectChange,
        tiny: true
      }), React.createElement(InputValidated, {
        onFocus: function onFocus(e) {
          e.target.select();
        },
        value: _this.state.value.value || '',
        className: 'ag-final-price-editor',
        onChange: _this.onInputChange,
        type: "number",
        tiny: true,
        validationError: _this.validation
      })));
    };

    return _this;
  }
  /** Method is overwritten to round value if exist */


  _createClass(ReleaseItemFinalPriceEditor, [{
    key: "initialState",
    value: function initialState() {
      /**
       * FIXME: there will be no finalPrice when there is no prices for competitor and finalPrice is editable anyway, there is no value on props
       */
      var data = this.props.value;
      return {
        value: data ? Object.assign(Object.assign({}, data), {
          value: data.valueRounded || data.value
        }) : Object.assign(Object.assign({}, data), {
          value: null
        }),
        validationError: null
      };
    }
    /** Validates input */

  }, {
    key: "componentWillMount",

    /**
     * Creating select options
     * and converting BigNumber to number
     */
    value: function componentWillMount() {
      if (!Utils.isValueMissing(this.OP)) {
        this[FinalPriceType.OptimalWithoutConstraints] = this.OP.toNumber();
        this.selectOptions.push(this.createSelectOption(FinalPriceType.OptimalWithoutConstraints));
      }

      if (!Utils.isValueMissing(this.OPW)) {
        this[FinalPriceType.OptimalWithConstraints] = this.OPW.toNumber();
        this.selectOptions.push(this.createSelectOption(FinalPriceType.OptimalWithConstraints));
      }

      if (!Utils.isValueMissing(this.ARP)) {
        this[FinalPriceType.Regular] = this.ARP.toNumber();
        this.selectOptions.push(this.createSelectOption(FinalPriceType.Regular));
      }
    }
    /** Allows to get focus on number input after cell focus */

  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      // Get focus to our number input
      var input = this.props.eGridCell.querySelector('input[type="number"]');

      if (input) {
        input.focus();
      }
    } //LOG-6390

  }, {
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      var validationResult = this.colDef.schema.validate(this.state.value, ValidationLevel.Fast); // const isBulk = this.props.context.store.showBulkRow && this.props.rowIndex === 0 && this.props.value === '';
      // const isBulk = this.props.context.store.showBulkRow && this.props.node.rowPinned === 'top';

      var isBulk = this.props.node.rowIndex === 0 && this.props.node.rowPinned === 'top';
      var bulkAction = this.colDef.bulkFunc;
      var actionFunc = isBulk && bulkAction ? bulkAction : this.colDef.action;
      console.log(this.validation);

      if (actionFunc && (Utils.isValueMissing(this.validation) || this.validation.valid) && validationResult.valid && validationResult.get() !== this.props.value && (this.props.value.valueRounded || this.props.value.value) !== this.state.value.value) {
        this.props.eGridCell.classList.remove('is-loading-ok', 'is-loading-error');
        this.props.eGridCell.classList.add('is-loading'); // Get validated value

        var validatedValue = validationResult.get(); // Set empty string value to null

        if (Utils.isString(validatedValue) && !validatedValue.length) {
          validatedValue = null;
        } // Call the backend to update the value


        actionFunc(this.props.node.id, this.props.column.getId(), validatedValue).then(function (value) {
          _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-ok');
        }, function (error) {
          _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-error');
        }).then(function () {
          if (isBulk) {
            // FIXME: we should update just all cells in specific column
            // this.props.api.redrawRows(); // LOG-2506
            _this2.props.api.refreshCells({
              columns: [_this2.props.column.getId()]
            });
          }

          _this2.setUpdatingDone(); // LOG-3758

        });
      } // If the value is successfully validated, return the parsed one...

      /* else */
      else if (validationResult.valid && this.validation && this.validation.valid) {
          console.log('A');
          return validationResult.get();
        } // ...otherwise return the original one


      return this.props.value;
    }
  }, {
    key: "validation",
    get: function get() {
      return this.state.value.value <= 0 || Utils.isValueMissing(this.state.value.value) ? new ValidationError('err-less-or-equal-zero') : null;
    } // OptimalWithoutConstraints

  }, {
    key: "OP",
    get: function get() {
      return this.props.node.data["ReleaseDetailCategory_".concat(this.state.value.priceZoneId, "_").concat(FinalPriceType.OptimalWithoutConstraints)];
    } // OptimalWithConstraints

  }, {
    key: "OPW",
    get: function get() {
      return this.props.node.data["ReleaseDetailCategory_".concat(this.state.value.priceZoneId, "_").concat(FinalPriceType.OptimalWithConstraints)];
    } // Regular

  }, {
    key: "ARP",
    get: function get() {
      return this.props.node.data["ReleaseDetailCategory_".concat(this.state.value.priceZoneId, "_").concat(FinalPriceType.Regular)];
    }
  }]);

  return ReleaseItemFinalPriceEditor;
}(CellEditor);
FinalPriceType.OptimalWithoutConstraints, FinalPriceType.OptimalWithConstraints, FinalPriceType.Regular;